import ChatInterfaceBase from './base'
import HitagiConnector from './hitagiconnector'

import hitagi from 'hitagi-js';

import {
    VIEW_STOP_REASON_LIMIT_REACHED
} from '../../constants/streaming';

import {
    PM_ACCESS_ALLOW,
    PM_ACCESS_DENY,
    PM_ACCESS_UNDEFINED,
    PM_ACCESS_RESET_REASON_REQUEST_CANCEL
} from '../../constants/pm';

import {
    ROOM_REFRESH_INTERVAL
} from '../../constants/rooms';

import {
    TOO_MANY_USERS_REASON,
    ANONYMOUS_NICK_ALREADY_EXISTS,
    BLACKLISTED_REASON,
    BLOCKED_REASON,
    EXCLUDED_REASON,
    NONEXISTENT_ROOM_REASON,
    ROOM_INACTIVE_REASON,
    PAYMENT_REQUIRED,
    INSUFFICIENT_FUNDS
} from "../../constants/chatInterface";

const BASE_LIB_LOADING_INTERVAL = 30000;
const BASE_LIB_LOADING_ATTEMPTS = 5;

export default class PmInterface extends ChatInterfaceBase {
    constructor(loginData, constraints) {
        super(loginData, constraints);

        this.hitagi = new hitagi(this._getLoginConfig);
        this.connector = new HitagiConnector(this.hitagi);
    }

    _getLoginConfig() {
        return {
            Uid: this.getUid(),
            Token: this.getToken(),
            ServerUri: this._loginData.pm_server_uri,
            ChatroomName: this._loginData.chatroom_name,
            AdditionalInfo: this._loginData.connection_id + "_" + window.fingerprint,
            "__debug__" : this._debug === "1"
        }
    }


    _onClose() {
        if (!this._disconnectedByServer && !this._loggedOut && !this.isAnonymous()) {
            this.startReconnection();
        }
    }

    bindBaseLib() {
        var that = this;

        this.hitagi.on('im:conversation_changed', function(Data) {
            that.trigger('pm_conversation_changed', Data);
        });

        this.hitagi.on('im:conversations', function(Data) {
            if(that._debug === "ws") console.log("pm_conversations", Data);
            that.trigger('pm_conversations', Data);
        });

        this.hitagi.on('im:conversation_user_login', function(User) {
            if(that._debug === "ws") console.log("pm_conversation_user_login", User.nick);
            that.trigger('pm_conversation_user_login', User);
        });
        this.hitagi.on('im:conversation_user_logout', function(User) {
            if(that._debug === "ws") console.log("pm_conversation_user_logout", User.nick);
            that.trigger('pm_conversation_user_logout', User);
        });
        this.hitagi.on('im:user_update', function(Data) {
            that.trigger('pm_user_update', Data);
        });

        this.hitagi.on("im:access_request", function (Request) { that.trigger('pm_access_request', Request) });

        this.hitagi.on('im:access_changed', function (Info) {
            switch (Info.access) {
            case PM_ACCESS_ALLOW: that.trigger('pm_access_change_allowed', Info); break;
            case PM_ACCESS_DENY: that.trigger('pm_access_change_denied', Info); break;
            case PM_ACCESS_UNDEFINED: that.trigger('pm_access_change_undefined', Info); break;
            }
        });

        this.hitagi.on('im:typing_notify', function(Notify) { that.trigger('typing_notify', Notify) });

        this.hitagi.on('im:history_deleted', function(HistoryDeleted) {
            that.trigger('delete_history', HistoryDeleted);
        });

        this.hitagi.on("im:message", function(Message) { that.trigger('pm_message', Message) });
        this.hitagi.on('close', function() { that.trigger('close') });
        this.on('close', this._onClose.bind(this));

        this.reconnect = this.reconnect.bind(this);
        this.updateReconnectionHandle = this.updateReconnectionHandle.bind(this);
        this.stopReconnection = this.stopReconnection.bind(this);

        this._reconnectionHandle = null;
        this._reconnectionInterval = 0;
        this._reconnectionIncrement = 5;
        this._reconnectionIntervalMax = 30;

        this.baseLibBound = true;
    }

    login(LoginConfig) {
        this.setAuthParams(LoginConfig);
        if (!this.getUid()) return;
        var that = this;
        this.hitagi.login(
            this._getLoginConfig(),
            function(User) {
                that.trigger('pm_login_success', User)
            },
            function(Code, Reason, Data) {
                that.trigger('pm_login_error', Code, Reason, Data)
            }
        );
    }

    startReconnection() {
        // reconnection already started
        if (this._reconnectionHandle) return false;

        this.updateReconnectionHandle();
    }

    forceReconnection() {
        this._disconnectedByServer = false;
        this.startReconnection();
    }

    stopReconnection() {
        clearTimeout(this._reconnectionHandle);
        this._reconnectionHandle = 0;
        this._reconnectionInterval = 0;
    }

    updateReconnectionHandle() {
        if (this._reconnectionInterval < this._reconnectionIntervalMax) this._reconnectionInterval += this._reconnectionIncrement;
        this._reconnectionHandle = setTimeout(this.reconnect, this._reconnectionInterval * 1000);
    }

    reconnect() {
        var that = this;
        this.trigger('pm_prereconnect');

        this.hitagi.login(
            this._getLoginConfig(),
            function(User) {
                that.stopReconnection();
                that.trigger('pm_reconnection_success');
                that.trigger('pm_login_success', User)

            },
            function() {
                console.log("chatInerface reconnect() error", arguments);
                that.trigger('pm_reconnection_error');
                that.updateReconnectionHandle();
            }
        );
    }

    fetchPmHistory(user) {
        let that = this;

        this.hitagi.im.status(
            user.uid,
            function (status) {
                // console.log(status);
                for (let i=0; i < status.history.length; i++) {
                    //that.trigger('pm_message', status.history[i]);
                }
                //that.trigger('pm_message', Message);
                let history = {
                    messages: status.history,
                    uid: user.uid
                }
                that.trigger('pm_history', history) });
    }

    markPmRead(recipient) {
        this.hitagi.im.markRead(recipient.uid);
    }

    // todo: move actual PM_SESSION_START action dispatching outside of ChatInterface, see also: UserContextMenu.pm()
    initiatePmSession(user, sendRequest = true) {
        this.trigger('pm_session_start', user);
        if (sendRequest) this.sendPmRequest(user);
        //this.fetchPmHistory(user);
    }

    sendPmRequest(user) {
        let that = this;

        this.hitagi.im.access_request(
            user.uid,
            function () { that.trigger('pm_session_accepted', user.uid) },
            function () { that.trigger('pm_session_declined', user.uid) }
        );
    }

    cancelPmRequest(uid) {
        this.trigger('pm_request_cancelled', uid);
        return this.hitagi.im.access_reset(uid, PM_ACCESS_RESET_REASON_REQUEST_CANCEL);
    }

    sendPmMessage(message, user, success, error) {
        this.hitagi.im.post_message(message, user.uid, success, error)
    };

    sendPmTypingNotify(uid) {
        this.hitagi.im.send_typing_notify(uid)
    }

    deleteHistory(uid) {
        // console.log('delete history');
        this.hitagi.im.delete_history(uid)
    }


    allowPmAccess(uid) {
        this.trigger('pm_session_accepted', uid);
        return this.hitagi.im.access_allow(uid);
    }

    denyPmAccess(uid) {
        this.trigger('pm_session_declined', uid);
        return this.hitagi.im.access_deny(uid);
    }

    resetPmAccess(user) {
        this.trigger('pm_session_declined', user.uid);
        return this.hitagi.im.access_deny(user.uid);
    }

    can(Permission) {
        if (this.hitagi.capabilities) {
            return this.hitagi.capabilities[Permission];
        } else {
            return false;
        }
    }

    onBaseLibNotLoaded(handler) { this.on('base_lib_not_loaded', handler) }


    _onClose() {
        console.log("onclose")
        if (!this._disconnectedByServer && !this._loggedOut && !this.isAnonymous()) {
    //        this.startReconnection();
        }
    }

    startReconnection() {
        console.log("startreconnection")
        if (this._reconnectionHandle) return false;

        this.updateReconnectionHandle();
    }

    forceReconnection() {
        this._disconnectedByServer = false;
        this.startReconnection();
    }

    stopReconnection() {
        clearTimeout(this._reconnectionHandle);
        this._reconnectionHandle = 0;
        this._reconnectionInterval = 0;
    }

    updateReconnectionHandle() {
        if (this._reconnectionInterval < this._reconnectionIntervalMax) this._reconnectionInterval += this._reconnectionIncrement;
        this._reconnectionHandle = setTimeout(this.reconnect, this._reconnectionInterval * 1000);
    }

    reconnect() {
        var that = this;
        //this.trigger('prereconnect');

        this.hitagi.login(
            this._getLoginConfig(),
            function(User) {
                that.stopReconnection();
                //that.trigger('reconnection_success');
                //that.trigger('login_success', User)

            },
            function() {
                console.log("chatInerface reconnect() error", arguments);
                //that.trigger('reconnection_error');
                that.updateReconnectionHandle();
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/interfaces/chat/pm.js